import React from 'react';
import { LabelBaseStyled } from './style';
import withTheme, { lightTheme } from 'helpers/theme';

const LabelBase = React.forwardRef(({ ...props }, ref) => {
  return <LabelBaseStyled ref={ref} {...props} />;
});

export default withTheme(lightTheme)(LabelBase);
